import { IColors } from 'common/contracts';
import { DefaultTheme } from 'styled-components';

const colors: IColors = {
  primary: '#006325',
  accent: '',
  bodyText: '#1D1D1D'
};

export const theme: DefaultTheme = {
  colors
};
